
export default superclass => class extends superclass  {

    // keeps track of the index of each SDF based on their ID
    idToIndex = {};
    indexCounter = 0;

    newSDF(id) {
        let index = this.indexCounter;

        this.idToIndex[id] = index;
        this.indexCounter++;

        return index;
    }

    getIndexForId(id) {
        let index = this.idToIndex[id];
        if (index === undefined) {
            index = this.newSDF(id);
        }
        return index;
    }
    
}
